import { PatientEncounterPage } from "./PatientEncounterPage";

export default PatientEncounterPage;
